/**************************************************
 * Nombre:       FilaEquipo
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     5 Hr
 **************************************************/
import {Avatar, AvatarGroup, Grid, Typography} from "@mui/material";
import React from "react";
import {reducirNombre} from "../../../CodNegocio/Funciones/reducirNombre";
import {useDialogo} from "../../../Modulo_Dialogos_2025/Hooks/useDialogo";
import Dialogo_Hijo from "../../Dialogos/Dialogo_Hijo";

const FilaEquipo = ({items = [], titulo, click, nivel}) => {



    return (
        <Grid
            container
            justifyContent={'flex-start'}
            alignItems={'center'}
            size={{xs: 12, sm: 12, md: 12}}

        >



            <Grid container size={{xs: 2, sm: 12, md: 1}} sx={{justifyContent: 'flex-start', mt: -2}}>
                <Grid
                    container
                    justifyContent={'flex-start'}
                    alignItems={'flex-start'}
                    size={{xs: 12, sm: 12, md: 12}}>

                    <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start'}}>
                        <Typography sx={{fontSize: 16, fontWeight: 600}}>{titulo}</Typography>
                    </Grid>


                </Grid>

            </Grid>

            <Grid container size={{xs: 10, sm: 12, md: 11}}
                  sx={{justifyContent: 'flex-start', alignItems: 'flex-start'}}>
                <AvatarGroup max={1000} spacing={10}>
                    {items.map((it, index) => (
                        <Grid
                            container
                            justifyContent={'center'}
                            alignItems={'flex-start'}
                            size={{xs: 12, sm: 12, md: 12}}
                            sx={{maxWidth: 100}}
                        >

                            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'center'}}>
                                <Avatar
                                    onClick={() => click(it, nivel, items)}
                                    alt={it.nombre} src={it.img}
                                    sx={{width: 52, height: 52, cursor: 'pointer'}}/>
                            </Grid>

                            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'center', mt: 0.5}}>
                                <Typography sx={{
                                    fontSize: 14,
                                    textAlign: 'center',
                                    width: 90,
                                    //backgroundColor: 'pink'
                                }}>{reducirNombre({
                                    nombre: it.nombre,
                                    largo: 11,
                                })}</Typography>
                            </Grid>

                        </Grid>


                    ))}
                </AvatarGroup>
            </Grid>


        </Grid>
    )

}
export default FilaEquipo